/**
 * Report Legend Content
 * Displays the legend items from report context
 */

import React from 'react';
import { cn } from '@ais-ui/utils';
import {
  IntervalItem,
  IntervalWithValueItem,
  LegendConfig,
  LegendType,
  TextItem,
} from '@ais-ui/websockets';
import {
  ItemInterval,
  ItemIntervalWithValue,
  ItemText,
  useGridColumns,
} from '../shared';

interface ReportLegendContentProps {
  legend: LegendConfig<LegendType>;
}

export const ReportLegendContent: React.FC<ReportLegendContentProps> = ({
  legend,
}) => {
  const gridColumnsClass = useGridColumns({
    itemCount: legend.items.length,
    maxItemsPerColumn: 12,
    maxColumns: 3,
  });

  const renderItems = () => {
    if (legend.type === 'intervalWithValue') {
      return legend.items.map((item, index) => (
        <ItemIntervalWithValue
          key={index}
          legend={legend}
          item={item as IntervalWithValueItem}
        />
      ));
    }

    if (legend.type === 'interval') {
      return legend.items.map((item, index) =>
        !(item as IntervalItem).text ? (
          <ItemInterval
            key={index}
            legend={legend}
            item={item as IntervalItem}
          />
        ) : (
          <ItemText key={index} item={item as TextItem} />
        ),
      );
    }

    return legend.items.map((item, index) => (
      <ItemText key={index} item={item as TextItem} />
    ));
  };

  return (
    <div className={cn('grid gap-y-1.5 gap-x-4', gridColumnsClass)}>
      {renderItems()}
    </div>
  );
};
